"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _jquery = _interopRequireDefault(require("jquery"));
var _reactModal = _interopRequireDefault(require("react-modal"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./modal.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var defaultModalClassName = 'Modal__Bootstrap modal-dialog ';

/** cccisd-modal provides you with bootstrap modal window */
var _default = /*#__PURE__*/function (_React$Component) {
  _inherits(_default, _React$Component);
  var _super = _createSuper(_default);
  function _default() {
    var _this;
    _classCallCheck(this, _default);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      isOpen: false,
      loading: false
    });
    _defineProperty(_assertThisInitialized(_this), "open", function () {
      _this._openModal();
    });
    _defineProperty(_assertThisInitialized(_this), "close", function () {
      _this._handleClose();
    });
    _defineProperty(_assertThisInitialized(_this), "_openModal", function (event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      if (_this.props.triggerDisabled) {
        return;
      }
      return new Promise(function (resolve, reject) {
        if (_this.props.beforeShow) {
          // Don't show loader if beforeShow is really fast
          var handle = setTimeout(function () {
            if (_this.props.beforeShowSpinner) {
              _this.setState({
                loading: true
              });
            }
          }, 100);
          Promise.resolve().then(function () {
            return _this.props.beforeShow();
          }).then(function () {
            clearTimeout(handle);
            _this.setState({
              isOpen: true,
              loading: false
            }, resolve);
          })["catch"](function () {
            clearTimeout(handle);
            _this.setState({
              loading: false
            });
          });
        } else {
          _this.setState({
            isOpen: true
          }, resolve);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_handleClose", function () {
      Promise.resolve(_this.props.beforeClose()).then(function () {
        if (_this.mounted) {
          _this.setState({
            isOpen: false
          });
        }
        if (_this.props.afterClose) {
          _this.props.afterClose();
        }
      })["catch"](function () {});
    });
    _defineProperty(_assertThisInitialized(_this), "_afterOpen", function () {
      if (_this.props.afterShow) {
        _this.props.afterShow();
      }

      // focus on the first form element
      if (_this.props.formAutoFocus) {
        (0, _jquery["default"])(_this.refs.body).find('input[type!="hidden"],textarea').first().focus();
      }
    });
    return _this;
  }
  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var modalStyle = {
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: this.props.onTop ? 2001 : 1050
        },
        content: _objectSpread({}, this.props.contentStyle)
      };
      var sizeClass = '';
      if (this.props.size === 'small') {
        sizeClass = 'modal-sm';
      } else if (this.props.size === 'large') {
        sizeClass = 'modal-lg';
      } else if (this.props.size !== 'normal') {
        modalStyle.content.width = this.props.size;
      }
      var modalBody = typeof this.props.render === 'function' ? this.props.render({
        closeModal: this.close
      }) : _react["default"].Children.map(this.props.children, function (child) {
        // If it's just dom element (like div) don't pass closeModal
        if (!child || typeof child.type === 'string') {
          return child;
        }
        return /*#__PURE__*/_react["default"].cloneElement(child, {
          closeModal: _this2.close
        });
      });
      var modalClassName = this.props.modalClassName + sizeClass;
      if (!modalClassName.startsWith(defaultModalClassName)) {
        modalClassName = defaultModalClassName + modalClassName;
      }
      return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.state.loading
      }, this.props.renderTrigger ? this.props.renderTrigger({
        onClick: this._openModal
      }) : /*#__PURE__*/_react["default"].createElement("span", {
        onClick: this._openModal
      }, this.props.trigger), /*#__PURE__*/_react["default"].createElement(_reactModal["default"], {
        isOpen: this.state.isOpen,
        className: modalClassName,
        closeTimeoutMS: 150,
        onRequestClose: this._handleClose,
        shouldCloseOnOverlayClick: false,
        style: modalStyle,
        onAfterOpen: this._afterOpen,
        ariaHideApp: false
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-header",
        style: _objectSpread({
          borderRadius: '6px 6px 0 0'
        }, this.props.headerStyle)
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "close",
        onClick: this._handleClose
      }, "\xD7"), /*#__PURE__*/_react["default"].createElement("h4", {
        className: "modal-title"
      }, this.props.title)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "modal-body",
        style: _objectSpread({
          borderRadius: '0 0 6px 6px'
        }, this.props.bodyStyle),
        ref: "body"
      }, modalBody))));
    }
  }]);
  return _default;
}(_react["default"].Component);
exports["default"] = _default;
_defineProperty(_default, "propTypes", {
  /** Any React component which will trigger the modal on click. <i>e.g.</i> <button>Open Modal</button> */
  trigger: _propTypes["default"].node,
  /** Function which will render trigger. It will get onClick callback as a param. */
  renderTrigger: _propTypes["default"].func,
  /** Function which will render children. It will get closeModal callback as a param. */
  render: _propTypes["default"].func,
  /** If true Modal won't open after clicking on the trigger  */
  triggerDisabled: _propTypes["default"].bool,
  /** Header title */
  title: _propTypes["default"].node,
  /** Width of the modal. Options: "small", "normal", "large"  */
  size: _propTypes["default"].string,
  /** Show modal window on top of everything else on the page. <i>e.g.</i> Over a spinner */
  onTop: _propTypes["default"].bool,
  /** A function that will run before the modal renders. <br> Promises will show a spinner before resolving then show the modal. */
  beforeShow: _propTypes["default"].func,
  /** If false, hide the spinner if beforeShow is taking a while (in case beforeShow is rendering its own)  */
  beforeShowSpinner: _propTypes["default"].bool,
  /** A function that will run after the modal is rendered. */
  afterShow: _propTypes["default"].func,
  /** A function that will run before the modal closes. <br> Promises will cause the modal to remain open until resolved. */
  beforeClose: _propTypes["default"].func,
  /** A function that will run after the modal closes. */
  afterClose: _propTypes["default"].func,
  /** Style of the modal content. */
  contentStyle: _propTypes["default"].object,
  /** Style of the modal header. */
  headerStyle: _propTypes["default"].object,
  /** Style of the modal body. */
  bodyStyle: _propTypes["default"].object,
  /** Will focus on the first field of a form when true. */
  formAutoFocus: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  /** "Modal__Bootstrap modal-dialog " will be prepended if not there already */
  modalClassName: _propTypes["default"].string
});
_defineProperty(_default, "defaultProps", {
  trigger: '',
  title: '',
  size: 'normal',
  onTop: false,
  beforeShowSpinner: true,
  beforeClose: function beforeClose() {},
  contentStyle: {},
  headerStyle: {},
  bodyStyle: {},
  formAutoFocus: false,
  modalClassName: defaultModalClassName
});